import { Box, styled } from '@mui/material';

export const Container = styled(Box)({
  display: 'flex',
  gap: 1,
  [`@container (max-width: 400px)`]: {
    display: 'none',
  },
});
